import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-fangdasuoxiao",
  "use": "icon-fangdasuoxiao-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-fangdasuoxiao\"><path d=\"M367.852966 489.329992l378.974102 378.11863L590.275689 1024l432.868839-1.710944 0.855472-432.013367-157.40685 157.406851L487.619048 369.56391 276.31746 157.40685 433.724311 0H0v433.724311l156.551378-156.551379L367.852966 489.329992z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol